import { __assign, __awaiter, __generator } from "tslib";
import { getThreeDsChallengeDisplaySize, renderIframeAndWaitForPostback, ThreeDsFormattingException, } from '../3d-secure';
import { logTaggedMessage } from '../../reporter';
import { stringify } from '../../../utils';
import { collectBrowserInfo } from '../collectBrowserInfo';
import { threeDsErrors } from '../3ds-utils';
var log = logTaggedMessage({
    module: '3ds',
    sub_moodule: 'worldpay-fingerprint',
});
var parseFingerprintPostData = function (postData) {
    if (typeof postData !== 'string') {
        throw new ThreeDsFormattingException("invalid type for Worldpay fingerprint postMessage data: ".concat(JSON.stringify(postData, null, 2)));
    }
    var parsedObj;
    try {
        parsedObj = JSON.parse(postData);
    }
    catch (e) {
        throw new ThreeDsFormattingException("failed to JSON parse invalid Worldpay fingerprint postData: ".concat(postData));
    }
    if (parsedObj.MessageType !== 'profile.completed' ||
        typeof parsedObj.Status !== 'boolean') {
        throw new ThreeDsFormattingException("invalid format for Worldpay fingerprint postMessage data: ".concat(postData));
    }
    return parsedObj;
};
export var performFingerprint = function (_a) {
    var methodUrl = _a.methodUrl, provider = _a.provider, bin = _a.bin, actionData = _a.data;
    return __awaiter(void 0, void 0, void 0, function () {
        function success(sessionId) {
            var dataToServer = {
                sessionId: sessionId,
                correlationId: correlationId,
            };
            return {
                fingerprintData: {
                    challengeDisplaySize: challengeDisplaySize,
                    provider: provider,
                    received: {},
                    data: dataToServer,
                    browserInfo: browserInfo,
                },
            };
        }
        function fail(error) {
            var dataToServer = {
                sessionId: '',
                correlationId: correlationId,
            };
            return {
                fingerprintData: {
                    challengeDisplaySize: challengeDisplaySize,
                    provider: provider,
                    notReceived: { error: error },
                    data: dataToServer,
                    browserInfo: browserInfo,
                },
            };
        }
        var browserInfo, _b, jwt, correlationId, challengeDisplaySize, reqData, logData, fingerprintResultPromise, fingerprintResult, sessionId, status_1, err, ret, e_1, ret;
        return __generator(this, function (_c) {
            switch (_c.label) {
                case 0:
                    browserInfo = collectBrowserInfo();
                    _b = actionData, jwt = _b.jwt, correlationId = _b.correlationId;
                    challengeDisplaySize = getThreeDsChallengeDisplaySize();
                    reqData = {
                        Bin: bin,
                        JWT: jwt,
                    };
                    logData = {
                        actionData: actionData,
                        methodUrl: methodUrl,
                        provider: provider,
                        reqData: reqData,
                        correlationId: correlationId,
                    };
                    log('3ds: before render 3ds Worldpay fingerprint iframe', logData);
                    fingerprintResultPromise = renderIframeAndWaitForPostback('hidden', methodUrl, 'POST', reqData).then(parseFingerprintPostData);
                    _c.label = 1;
                case 1:
                    _c.trys.push([1, 3, , 4]);
                    return [4 /*yield*/, fingerprintResultPromise];
                case 2:
                    fingerprintResult = _c.sent();
                    sessionId = fingerprintResult.SessionId, status_1 = fingerprintResult.Status;
                    if (status_1 !== true || !sessionId) {
                        err = "bad worldpay fingerprint result: ".concat(stringify(fingerprintResult));
                        ret = fail(err);
                        log("3ds: Worldpay Device Fingerprint failed", __assign(__assign({}, logData), { err: err, ret: ret }));
                        return [2 /*return*/, ret];
                    }
                    log('3ds: received Worldpay fingerprint success', __assign(__assign({}, logData), { fingerprintResult: fingerprintResult }));
                    return [2 /*return*/, success(sessionId)];
                case 3:
                    e_1 = _c.sent();
                    ret = fail(threeDsErrors.generate3dsError({
                        providerFlow: 'WORLDPAY',
                        step: 'fingerprint',
                        e: e_1,
                    }));
                    log("3ds: Worldpay Device Fingerprint failed", __assign(__assign({}, logData), { ret: ret, e: e_1 }));
                    return [2 /*return*/, ret];
                case 4: return [2 /*return*/];
            }
        });
    });
};
//# sourceMappingURL=worldpay-fingerprint.js.map